import { jwtDecode } from "jwt-decode";

class Auth {
  static getToken() {
    return localStorage.getItem("admin_token");
  }

  static getUser() {
    const token = this.getToken();

    if (token) {
      try {
        return jwtDecode(token);
      } catch (error) {
        console.error("Invalid token");
        return null;
      }
    }
    return null;
  }

  static getUserDetails(key = null) {
    const user = this.getUser();
    return key && user ? user[key] : user || "";
  }

  static logout() {
    localStorage.removeItem("admin_token");
    window.location.href = "/";
  }
}

export default Auth;
